import React from 'react';

const TickIcon = ({ 
  width = 16, 
  height = 16, 
  strokeColor = "#2B3674",
  strokeWidth = 2.5,
  className = "" 
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.3307 4L5.9974 11.3333L2.66406 8"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TickIcon;